<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import Button from "@/dsComponents/buttons/Button.vue";
import TextareaInput from "@/dsComponents/inputs/TextareaInput.vue";
import Modal from "@/dsComponents/modals/Modal.vue";

interface Props {
    open: boolean;
    onConfirm: (reason: string) => void;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    close: [];
}>();

const { t } = useI18n();

const rejectReason = ref("");
const rejectReasonError = ref("");

const handleConfirm = () => {
    if (!rejectReason.value.trim()) {
        rejectReasonError.value = t("errors.required");
        return;
    }

    props.onConfirm(rejectReason.value);
    handleClose();
};

const handleClose = () => {
    rejectReason.value = "";
    rejectReasonError.value = "";
    emit("close");
};
</script>
<template>
    <Modal :open="open" :title="t('modals.workerReject.agency.title')" :action="true" width="500px" @close="handleClose">
        <p>{{ t("modals.workerReject.agency.description") }}</p>
        <TextareaInput
            :label="t('form.message')"
            v-model="rejectReason"
            :rows="2"
            :error="rejectReasonError"
            @update:model-value="rejectReasonError = ''"
        />
        <template #footer>
            <div class="button-container">
                <Button size="sm" type="neutral" variant="ghost" :label="t('global.actions.cancel')" @click="handleClose" />
                <Button size="sm" :label="t('global.actions.confirm')" @click="handleConfirm" />
            </div>
        </template>
    </Modal>
</template>
<style scoped lang="scss">
.button-container {
    display: flex;
    gap: var(--spacing-lg, 12px);
    justify-content: flex-end;
}
</style>
